const StarIcon = ({ filled, ...props }) => (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={filled ? "#ffc107" : "none"} 
      stroke={filled ? "#ffc107" : "#ccc"}
      {...props}
    >
      <path
        d="M10,15,4.122,18.09l1.123-6.545L.489,6.91l6.572-.955L10,0l2.939,5.955,6.572.955-4.755,4.635,1.123,6.545Z"
        transform="translate(2 3)"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </svg>
  );
  
  export default StarIcon;
  